export default __webpack_public_path__ + "static/media/HotelPerDay.4d9304b1.svg";